import { createApp } from 'vue';
import { createPinia } from 'pinia';
import VueSanitizeHtml, { DEFAULT_ALLOWED_TAGS } from '@/plugins/vue-sanitize-html';
import App from '@/App.vue';
import Logger from '@/helper-classes/Logger';
import '@/assets/main.css';

window.sc3WorkbenchLogger = new Logger();

const pinia = createPinia();
const app = createApp(App);

app.use(pinia);
app.use(VueSanitizeHtml, { allowedTags: DEFAULT_ALLOWED_TAGS });
app.mount('#app');
